// extracted by mini-css-extract-plugin
export default {"pricing":"pricing_pricing__6zyVh","priceSplit":"pricing_priceSplit__zV4x8"};